module.exports = __webpack_public_path__ + "img/realize.cdbb9e8d.png";